<section class="cta">
    <div class="container">
      <h2 class="cta__title">{{ title }}</h2>
      <p class="cta__subtitle">{{ subtitle }}</p>
      <div class="cta__actions">
        <button 
          class="cta__btn cta__btn--primary" 
          (click)="onPrimaryAction()">
          {{ primaryButtonText }}
        </button>
        <button 
          class="cta__btn cta__btn--secondary" 
          (click)="onSecondaryAction()">
          {{ secondaryButtonText }}
        </button>
      </div>
    </div>
  </section>